import { VisualThemeConfig, VisualThemeId } from '../types/theme';

export const VISUAL_THEME_PRESETS: VisualThemeConfig[] = [
  {
    id: 'twopoint',
    name: 'AVAP Digital Twin',
    category: 'others',
    categoryLabel: 'AVAP Digital Twin (Default)',
    gameInspiration: 'Digital Twin Sim & Space Operation',
    tagline: 'Pastel mint, vibrant coral, and high-definition management cards',
    description:
      'Default visual styling for AVAP Digital Twin. Pastel mint tones paired with coral and high-visibility accents, modern typography, and high-contrast spatial management cards.',
    badgeText: 'Default',
    iconType: 'activity',
    previewColors: ['#14b8a6', '#f43f5e', '#134e4a', '#eab308'],
    styles: {
      primaryColor: '#14b8a6',
      primaryLight: '#5eead4',
      secondaryColor: '#f43f5e',
      accentGlow: 'rgba(20, 184, 166, 0.3)',
      headerBg: 'rgba(13, 33, 40, 0.96)',
      headerBorder: '#115e59',
      cardBg: '#0d2229',
      cardBgSubtle: '#133541',
      cardBorder: '#0f766e',
      surfaceBg: '#051317',
      activeTabBg: '#134e4a',
      textMain: '#f0fdfa',
      textMuted: '#99f6e4',
      fontFamily: "'Outfit', system-ui, sans-serif",
      fontHeading: "'Outfit', system-ui, sans-serif",
      canvasBg: '#07181c',
      canvasBaseTileEven: '#115e59',
      canvasBaseTileOdd: '#134e4a',
      canvasGridLine: 'rgba(45, 212, 191, 0.3)',
      canvasSelection: '#2dd4bf',
      canvasHighlight: '#99f6e4',
      uiBorderRadius: '16px',
      fontStyle: 'arcade',
    },
  },
  {
    id: 'avap_commander',
    name: 'AVAP Commander',
    category: 'commander',
    categoryLabel: 'AVAP Commander Enterprise',
    gameInspiration: 'AVAP Cloud v3.15 / Brunix 3.15 Intelligence Cloud',
    tagline: 'Carbon onyx black, fire orange accents, and precision micro-borders',
    description:
      'Inspired by the AVAP Commander Cloud v3.15 interface. Pure onyx base (#09090b / #111116), warm rust orange action buttons and highlights (#ea580c / #f97316), sky blue status badges, crisp high-density typography, and isometric grid with copper accents.',
    badgeText: 'Enterprise',
    iconType: 'flame',
    previewColors: ['#ea580c', '#f97316', '#111116', '#3b82f6'],
    styles: {
      primaryColor: '#ea580c',
      primaryLight: '#fb923c',
      secondaryColor: '#3b82f6',
      accentGlow: 'rgba(234, 88, 12, 0.35)',
      headerBg: 'rgba(9, 9, 11, 0.98)',
      headerBorder: '#27272a',
      cardBg: '#111116',
      cardBgSubtle: '#18181f',
      cardBorder: '#27272a',
      surfaceBg: '#09090b',
      activeTabBg: '#2b1408',
      textMain: '#f4f4f5',
      textMuted: '#a1a1aa',
      fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
      fontHeading: "'Plus Jakarta Sans', system-ui, sans-serif",
      canvasBg: '#09090c',
      canvasBaseTileEven: '#14141b',
      canvasBaseTileOdd: '#1c1c24',
      canvasGridLine: 'rgba(234, 88, 12, 0.28)',
      canvasSelection: '#f97316',
      canvasHighlight: '#ffedd5',
      uiBorderRadius: '10px',
      fontStyle: 'modern',
    },
  },
];

export const DEFAULT_THEME_ID: VisualThemeId = 'twopoint';

export const getThemeConfig = (themeId: VisualThemeId | string): VisualThemeConfig => {
  const found = VISUAL_THEME_PRESETS.find((t) => t.id === themeId);
  return found || VISUAL_THEME_PRESETS[0];
};
